import { Calendar, Boxes, PhoneCall, Mail, MessageSquare, BarChart3, Cloud, BellRing, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal, SectionHeading } from '../components/Reveal';

const CHIPS = [
  { icon: <Calendar className="h-4 w-4" />, label: 'Google Calendar' },
  { icon: <Boxes className="h-4 w-4" />, label: 'CRM Integration' },
  { icon: <PhoneCall className="h-4 w-4" />, label: 'Business Phone Systems' },
  { icon: <Mail className="h-4 w-4" />, label: 'Email' },
  { icon: <MessageSquare className="h-4 w-4" />, label: 'SMS' },
  { icon: <BarChart3 className="h-4 w-4" />, label: 'Call Analytics' },
  { icon: <Cloud className="h-4 w-4" />, label: 'Cloud Storage' },
  { icon: <BellRing className="h-4 w-4" />, label: 'Lead Notifications' },
];

const CARDS = [
  {
    title: 'Seamless Integration',
    copy: 'Connect with your existing tools in minutes.',
  },
  {
    title: 'Powerful Work Integration',
    copy: 'Sync with essential work tools to boost productivity.',
  },
];

export const Integrations = () => (
  <section className="py-20 lg:py-28" id="integrations" data-testid="integrations-section">
    <div className="container-x">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          eyebrow="Integration"
          title="Connect Everything in One Place"
          sub="CapableBee works silently in the background generating leads for you."
        />
      </div>

      <div className="mt-12 grid gap-5 lg:grid-cols-2">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} data-testid={`integration-card-${i}`}>
            <div className="group flex h-full flex-col justify-between gap-8 rounded-3xl border border-brand-line bg-white p-8 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-lift">
              <div>
                <h3 className="text-xl font-bold tracking-tight text-brand-navy">{c.title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-600">{c.copy}</p>
              </div>
              <Link
                to="/contact"
                data-testid={`integration-cta-${i}`}
                className="inline-flex w-fit items-center gap-2 text-sm font-bold text-brand-skyDeep transition-colors hover:text-brand-navy"
              >
                Connect Now
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.12}>
        <ul className="mt-8 flex flex-wrap justify-center gap-3" data-testid="integration-chips">
          {CHIPS.map((c) => (
            <li
              key={c.label}
              className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-white px-4 py-2.5 text-sm font-semibold text-brand-body shadow-card transition-all hover:-translate-y-0.5 hover:border-brand-lineBlue hover:text-brand-navy"
            >
              <span className="text-brand-skyDeep">{c.icon}</span>
              {c.label}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
